"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/styles");
const lab_1 = require("@material-ui/lab");
const Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
const DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
const DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
const DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const svgIcons_1 = require("../../../../../svgIcons");
require("./practiceAreaModal.scss");
const useTreeStyles = {
    root: {
        height: 240,
        flexGrow: 1,
        maxWidth: 400,
        fontSize: "12",
    },
    content: {
        flexDirection: "row-reverse"
    },
    labelRoot: {
        display: "flex",
        alignItems: "center",
        padding: "7.5px"
    },
    labelIcon: {
        marginRight: "10px"
    },
    labelText: {
        fontFamily: 'HelveticaNeueCyr-Medium, Helvetica, sans-serif',
        fontWeight: 500,
        flexGrow: 1,
        fontSize: '14px',
        textTransform: 'capitalize',
    },
    childLabelText: {
        fontFamily: 'HelveticaNeueCyr-Roman, Helvetica, sans-serif',
        fontWeight: 400,
        flexGrow: 1,
        fontSize: '14px',
        textTransform: 'capitalize'
    },
    labelContainer: {
        display: 'inline-flex',
        alignItems: 'center'
    },
    checkbox: {
        color: '#DFDFE6',
        borderRadius: 4,
        padding: '7.5px 10px 7.5px 0'
    },
    checkedIcon: {
        backgroundColor: '#2EA0DC',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        borderRadius: 4,
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
    },
    checkedParentPart: {
        backgroundColor: '#ffffff',
        border: 'none',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            color: '#333333',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='2' viewBox='0 0 12 2'%3E%3Cg id='Group_673' data-name='Group 673' transform='translate(-375.33 -440)'%3E%3Crect id='Rectangle_266' data-name='Rectangle 266' width='2' height='12' rx='1' transform='translate(387.33 440) rotate(90)' fill='%23333'/%3E%3C/g%3E%3C/svg%3E%0A")`,
            content: '""',
        },
    }
};
class PracticeAreaModal extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            old: [],
            changes: [],
            allSubtypesLength: 0,
            expanded: []
        };
        this.handleChange = (e) => {
            var _a;
            const { old, changes } = this.state;
            const { staticData: { caseTypes } } = this.props;
            let checked = e.target.checked;
            const value = e.target.value;
            const checkedCaseType = lodash_1.default.filter(caseTypes, { name: value });
            //if checked parent
            if (checkedCaseType.length) {
                let notSelected = [];
                //saved old areas
                const selected = old.filter((i) => i.case_type_id === checkedCaseType[0].id);
                //new checks that haven't saved yet
                const selectedChanges = changes.filter((i) => i.case_type_id === checkedCaseType[0].id && !i.deleted);
                //get subtypes that didn't checked
                if (selected.length + selectedChanges.length !== checkedCaseType[0].subTypes.length) {
                    notSelected = lodash_1.default.differenceWith(checkedCaseType[0].subTypes, selected, (a, s) => a.case_sub_type_id == s.case_sub_type_id);
                    checked = !!(notSelected === null || notSelected === void 0 ? void 0 : notSelected.length);
                }
                else {
                    //if all subtypes don't checked
                    notSelected = checkedCaseType[0].subTypes;
                }
                //prepare data for update redux state
                const state = this.processSelection(old, changes, notSelected, checked);
                this.props.changeArea(state, 'temp');
            }
            //if checked sub type
            else {
                //find subtype
                const case_sub_type_id = Number(e.target.id);
                const item = lodash_1.default.find((_a = lodash_1.default.filter(caseTypes, { subTypes: [{ id: case_sub_type_id }] })[0]) === null || _a === void 0 ? void 0 : _a.subTypes, { 'id': case_sub_type_id });
                //prepare for update redux state
                const state = this.processSelection(old, changes, [item], checked);
                if (state) {
                    this.props.changeArea(state, 'temp');
                }
            }
        };
        this.toggleAll = (e) => {
            const { old, changes } = this.state;
            const { staticData: { caseTypes } } = this.props;
            const checkedAll = e.target.checked;
            //store locally then send to redux
            let mutate = {
                changes: [...changes],
                old: [...old],
                changed: true
            };
            if (checkedAll) {
                for (const ct of caseTypes) {
                    let notSelected = [];
                    const allChildChecked = this.ifAllSubTypesChecked(old, changes, ct);
                    const selected = old.filter((i) => i.case_type_id === ct.id);
                    if (allChildChecked) {
                        notSelected = lodash_1.default.differenceWith(ct.subTypes, selected, (a, s) => a.case_sub_type_id == s.case_sub_type_id);
                    }
                    else {
                        //if all subtypes don't checked then check them
                        notSelected = ct.subTypes;
                    }
                    //prepare for update redux state
                    const state = this.processSelection(mutate.old, mutate.changes, notSelected, checkedAll);
                    //update data after each iteration
                    mutate = state;
                }
                this.props.changeArea(mutate, 'temp');
            }
            else {
                //if there exist old items mark them as deleted
                this.props.changeArea({
                    changes: (old === null || old === void 0 ? void 0 : old.length) ? old.map((o) => {
                        return Object.assign(Object.assign({}, o), { deleted: true });
                    }) : [],
                    old: [],
                    changed: true
                }, 'temp');
            }
        };
        this.handleExpanded = (nodeId, nodeExpanded) => {
            if (nodeExpanded) {
                this.setState({ expanded: nodeExpanded });
            }
            else {
                const diff = lodash_1.default.difference(this.state.expanded, nodeExpanded);
                this.setState({ expanded: diff });
            }
        };
        this.processSelection = (old, changes, checkes, checked) => {
            const mutate = {
                changes: [...changes],
                old: [...old],
                changed: true
            };
            if (checked) {
                const { profile: { practiceArea: { static: { old: oldS, changes: changesS } } } } = this.props;
                const inOld = lodash_1.default.intersectionBy(oldS, checkes, 'case_sub_type_id');
                //old area checked then unchecked
                if (inOld === null || inOld === void 0 ? void 0 : inOld.length) {
                    mutate.old = mutate.old.concat(inOld);
                    checkes = lodash_1.default.differenceBy(checkes, inOld, 'case_sub_type_id');
                    mutate.changes = lodash_1.default.differenceBy(mutate.changes, inOld, 'case_sub_type_id');
                }
                //new area checked then unchecked
                mutate.changes = mutate.changes.concat(checkes.map((e) => {
                    return Object.assign(Object.assign({}, e), { deleted: null });
                }));
            }
            else {
                for (let c of checkes) {
                    const inChange = mutate.changes.find((i) => i.case_sub_type_id === c.case_sub_type_id);
                    const inOld = mutate.old.find((i) => i.case_sub_type_id === c.case_sub_type_id);
                    // unchecked items from changes
                    if (inChange) {
                        mutate.changes = mutate.changes.filter((i) => i.case_sub_type_id !== c.case_sub_type_id);
                    }
                    // unchecked items from old
                    else if (inOld) {
                        mutate.changes.push(Object.assign(Object.assign({}, inOld), { deleted: true }));
                        mutate.old = mutate.old.filter((i) => i.case_sub_type_id !== c.case_sub_type_id);
                    }
                }
            }
            return {
                changes: lodash_1.default.uniqBy(mutate.changes, 'case_sub_type_id'),
                old: lodash_1.default.uniqBy(mutate.old, 'case_sub_type_id'),
                changed: true
            };
        };
        this.ifAllSubTypesChecked = (old, changes, caseType) => {
            let allChildChecked = false;
            const selected = old.filter((i) => i.case_type_id === caseType.id);
            //new checks that haven't saved yet
            const selectedChanges = changes.filter((i) => i.case_type_id === caseType.id && !i.deleted);
            //find if all sub types is checked
            allChildChecked = caseType.subTypes.length === selected.length + selectedChanges.length;
            if (!allChildChecked) {
                allChildChecked = caseType.subTypes.length === selected.length;
            }
            if (!allChildChecked) {
                allChildChecked = caseType.subTypes.length === selectedChanges.length;
            }
            return allChildChecked;
        };
        this.saveChanges = () => {
            const { profile: { practiceArea }, user } = this.props;
            this.updateDeleted(practiceArea);
            this.props.savePracticeAreas(practiceArea, user.id);
            this.props.togglePracticeAreasModal();
        };
        this.neverMind = () => {
            this.setState({ old: [], changes: [] });
            const { profile: { practiceArea: { static: { old } } } } = this.props;
            this.props.changeArea({
                changes: [],
                old: lodash_1.default.uniqBy(old, 'case_sub_type_id'),
                changed: true
            }, 'temp');
            this.props.togglePracticeAreasModal();
        };
    }
    componentDidMount() {
        const { profile: { practiceArea: { static: { old, changes } } }, staticData: { caseTypes } } = this.props;
        const all = lodash_1.default.flatten(lodash_1.default.cloneDeep(caseTypes).map((ct) => ct.subTypes));
        this.setState({ old, changes, allSubtypesLength: all.length });
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { profile: { practiceArea: { temp: { old, changes } } } } = this.props;
        if (!lodash_1.default.isEqual(old, this.state.old)) {
            this.setState({ old });
        }
        if (!lodash_1.default.isEqual(changes, this.state.changes)) {
            this.setState({ changes });
        }
    }
    ifAllChecked() {
        let { old, changes, allSubtypesLength } = this.state;
        old = old.filter((i) => !i.deleted);
        changes = changes.filter((i) => !i.deleted);
        let allChecked = allSubtypesLength === (old.length + changes.length);
        if (!allChecked) {
            allChecked = allSubtypesLength === old.length;
        }
        if (!allChecked) {
            allChecked = allSubtypesLength === changes.length;
        }
        return allChecked;
    }
    ;
    updateDeleted(practiceArea) {
        const diff = lodash_1.default.difference(practiceArea.static.old, practiceArea.temp.old);
        const deletedList = diff.map((i) => {
            return Object.assign(Object.assign({}, i), { deleted: true });
        });
        if (deletedList.length > 0) {
            this.props.changeArea({
                changes: deletedList,
                old: practiceArea.temp.old,
                changed: true
            }, 'temp');
        }
    }
    render() {
        const { old, changes } = this.state;
        const { staticData: { caseTypes }, classes } = this.props;
        const allChecked = this.ifAllChecked();
        const getTreeItemsFromData = (treeItems) => {
            return treeItems === null || treeItems === void 0 ? void 0 : treeItems.map(treeItemData => {
                let children = undefined, selectedAny = undefined, allChildChecked = undefined, isChild = !!treeItemData.case_type_id, checked = !!old.find(i => i.case_sub_type_id === treeItemData.case_sub_type_id && !i.deleted && isChild) ||
                    !!changes.find(i => i.case_sub_type_id === treeItemData.case_sub_type_id && !i.deleted && isChild);
                //if item is case type
                if (!isChild) {
                    //recursively process sub types
                    children = getTreeItemsFromData(treeItemData.subTypes);
                    //filter saved old areas
                    let oldLength = old.filter(i => i.case_type_id === treeItemData.id && !i.deleted).length;
                    //filter new checked areas
                    let changesLength = changes.filter(i => i.case_type_id === treeItemData.id && !i.deleted).length;
                    //find if all sub types is checked
                    allChildChecked = treeItemData.subTypes.length === oldLength + changesLength;
                    if (!allChildChecked) {
                        allChildChecked = treeItemData.subTypes.length === oldLength;
                    }
                    if (!allChildChecked) {
                        allChildChecked = treeItemData.subTypes.length === changesLength;
                    }
                    //find if all sub types is checked end
                    //find if checked any sub type
                    selectedAny = !!(changes.find(i => i.case_type_id === treeItemData.id && !i.deleted) || old.find(i => i.case_type_id === treeItemData.id && !i.deleted));
                }
                const label = (react_1.default.createElement("div", { className: classes.labelContainer },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(core_1.Checkbox, { disableRipple: true, value: treeItemData.name, id: String(treeItemData.id), checked: checked || allChildChecked || (selectedAny && !allChildChecked && !checked), onChange: (e) => (this.handleChange(e)), className: classes.checkbox, onClick: (e) => (e.preventDefault()), icon: react_1.default.createElement(svgIcons_1.CheckboxUnchecked, null), checkedIcon: react_1.default.createElement("span", { className: isChild || allChildChecked ? classes.checkedIcon : classes.checkedParentPart }) })),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("label", { style: { cursor: "pointer" }, htmlFor: isChild ? treeItemData.name : '', className: isChild ? classes.childLabelText : classes.labelText }, treeItemData.name))));
                return (react_1.default.createElement(lab_1.TreeItem, { className: isChild ? 'child-item' : 'parent-item', key: treeItemData.id, nodeId: treeItemData.name + treeItemData.id, label: label, children: children, classes: {
                        content: classes.content
                    } }));
            });
        };
        const DataTreeView = ({ treeItems }) => {
            return (react_1.default.createElement(lab_1.TreeView, { expanded: this.state.expanded, onNodeToggle: (nodeId, nodeExpanded) => this.handleExpanded(nodeId, nodeExpanded), defaultCollapseIcon: react_1.default.createElement("span", { style: { transform: ' rotate(180deg)' } },
                    react_1.default.createElement(svgIcons_1.DropdownIcon, { fill: "#2EA0DC" })), defaultExpandIcon: react_1.default.createElement("span", null,
                    react_1.default.createElement(svgIcons_1.DropdownIcon, null)) }, getTreeItemsFromData(treeItems)));
        };
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(Dialog_1.default, { open: true, scroll: 'paper', onClose: this.neverMind, className: "practice-area-dialog", "aria-labelledby": "scroll-dialog-title", "aria-describedby": "scroll-dialog-description" },
                react_1.default.createElement(DialogTitle_1.default, { className: "select-all-labelContainer", id: "scroll-dialog-title" },
                    react_1.default.createElement("div", { className: classes.labelContainer },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(core_1.Checkbox, { disableRipple: true, checked: allChecked, value: 'Select All', onChange: this.toggleAll, className: `${classes.checkbox} `, icon: react_1.default.createElement(svgIcons_1.CheckboxUnchecked, null), checkedIcon: react_1.default.createElement("span", { className: classes.checkedIcon }) })),
                        react_1.default.createElement("span", { className: classes.labelText }, 'Select All'))),
                react_1.default.createElement(Divider_1.default, null),
                react_1.default.createElement(DialogContent_1.default, null,
                    react_1.default.createElement(DataTreeView, { treeItems: caseTypes })),
                react_1.default.createElement(Divider_1.default, null),
                react_1.default.createElement(DialogActions_1.default, null,
                    react_1.default.createElement(core_1.Button, { onClick: this.saveChanges, onDoubleClick: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }, disableRipple: true, className: "v2-btn v2-btn-primary" }, "Save"),
                    react_1.default.createElement(core_1.Button, { onClick: this.neverMind, disableRipple: true, className: "v2-btn v2-btn-tertiary" }, "Never Mind")))));
    }
}
const mapStateToProps = (state) => {
    const { staticData } = state;
    return {
        staticData,
    };
};
exports.default = react_redux_1.connect(mapStateToProps, null)(styles_1.withStyles(useTreeStyles)(PracticeAreaModal));
